import styled from "styled-components";

export const ModalContainer = styled.div.attrs({})`
  position: absolute;
  inset: 0 0 0 0;
  background: ${(props) => props.theme.palette.colors.darkshadow};
  z-index: 4;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const LogsContainer = styled.div.attrs({})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  overflow-y: auto;
  max-height: 400px;
`;

export const Log = styled.div.attrs({})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  padding: 12px;

  border: 1px solid ${(props) => props.theme.palette.colors.borderline};
  border-radius: 8px;
  
  & p {
    margin: 0;
    font-size: 14px;
    color: ${(props) => props.theme.palette.colors.text};
  }
`;

export const HeaderLog = styled.div.attrs({})`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const CardHomeContentLabel = styled.div.attrs({})`
  padding: 4px 16px 4px 8px;
  background: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.greenLight
      : props.theme.palette.colors.purpleLight};
  border-radius: 32px;
  display: flex;
  align-items: center;
`;

export const CardHomeContentLabelDecoration = styled.img.attrs((props) => ({
  src: props.isSuccess ? "/icons/approved.svg" : "/icons/info.svg",
}))`
  width: 13px;
  height: 13px;
  margin: 0 8px 0 0;
`;

export const CardHomeContentLabelText = styled.div.attrs({})`
  font-size: 14px;
  color: ${(props) =>
    props.isSuccess
      ? props.theme.palette.colors.green
      : props.theme.palette.colors.blue};
`;